import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const UsersIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        opacity="0.2"
        d="M11 20C14.5899 20 17.5 17.0899 17.5 13.5C17.5 9.91015 14.5899 7 11 7C7.41015 7 4.5 9.91015 4.5 13.5C4.5 17.0899 7.41015 20 11 20Z"
        fill="#2E2E2E"
      />
      <path
        d="M11 20C14.5899 20 17.5 17.0899 17.5 13.5C17.5 9.91015 14.5899 7 11 7C7.41015 7 4.5 9.91015 4.5 13.5C4.5 17.0899 7.41015 20 11 20Z"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M19.4219 7.24166C20.3159 6.98977 21.2535 6.93239 22.1716 7.07338C23.0897 7.21437 23.9669 7.55046 24.7441 8.05901C25.5213 8.56756 26.1806 9.23677 26.6774 10.0216C27.1742 10.8063 27.4971 11.6885 27.6243 12.6086C27.7515 13.5287 27.6801 14.4653 27.4148 15.3555C27.1495 16.2456 26.6966 17.0686 26.0864 17.7689C25.4763 18.4693 24.7232 19.0307 23.8778 19.4155C23.0324 19.8003 22.1144 19.9994 21.1856 19.9995"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 24.6746C3.01517 23.2306 4.36287 22.052 5.92931 21.2384C7.49576 20.4248 9.23497 20.0001 11.0001 20C12.7652 19.9999 14.5045 20.4246 16.071 21.238C17.6375 22.0515 18.9853 23.23 20.0006 24.6739"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.1875 20C22.9528 19.9987 24.6924 20.4228 26.259 21.2364C27.8257 22.05 29.1732 23.2291 30.1875 24.6739"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UsersIcon;
